module.exports = require("@aws-sdk/client-codepipeline");